import { z } from "zod";
import { FieldLayoutSchema, FieldPropsSchema } from "./field.schema";
import { EmailTemplateSchema } from "./emailTemplate.schema";
import { ExampleFileSchema } from "./exampleFile.schema";
import { MeetingTypeTypeSchema } from "./meeting.schema";
import { MotionTypeSchema } from "./motion.schema";
import { TermsAndConditionsSchema } from "./termsAndConditions.schema";
import { OrganizationTypeSchema } from "./tenant.schema";
import { UploadTypeIdSchema } from "./document.schema";

// Schemas

export const AppConfigSchema = z.object({
  connected: z.boolean(),
  environment: z.string(),
  adminUrl: z.string(),
  apiUrl: z.string(),
  sitesUrl: z.string(),
});

export const AgendaItemMetadataConfigSchema = z.object({
  fields: FieldPropsSchema.array(),
  layout: FieldLayoutSchema,
});

export const EmailTemplatesConfigSchema = z.record(EmailTemplateSchema);

export const ExampleFilesConfigSchema = z.object({
  userImportExample: ExampleFileSchema,
});

export const MeetingTypesConfigSchema = z.object({
  meetingTypes: MeetingTypeTypeSchema.array(),
});

export const DocumentUploadTypesConfigSchema = z.object({
  uploadTypes: z
    .object({
      id: UploadTypeIdSchema,
      label: z.string(),
      storage: z.enum(["short", "long"]),
      example: z.string(),
    })
    .array(),
});

export const OrganizationTypesConfigSchema = z.object({
  organizationTypes: OrganizationTypeSchema.array(),
});

export const MotionTypesConfigSchema = z.object({
  item: MotionTypeSchema.array(),
  meeting: MotionTypeSchema.array(),
});

export const TermsAndConditionsConfigSchema =
  TermsAndConditionsSchema.partial();
